import { render } from "./ServicioDetalle.vue?vue&type=template&id=e92d3d72&ts=true"
import script from "./ServicioDetalle.vue?vue&type=script&lang=ts"
export * from "./ServicioDetalle.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__